import styled from 'styled-components';

const MobileLayoutWrapper = styled.div`
  display: grid;
  height: 100vh;
  grid-template-rows: 1fr 9fr;
`;

export { MobileLayoutWrapper };
